import * as types from './actionTypes';

const initialState = {
  list: [],
  isLoaded: false,
  isLoading: false,
  error: '',
  cardSelect: {
    cardId: null,
    payuToken: null,
  },
};

export default function payuCardReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_LIST_REQUEST:
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: '',
      };

    case types.FETCH_LIST_SUCCESS: {
      const list = action.payload;
      const firstCardId = list?.[0]?.id ?? null;
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        list,
        error: '',
        cardSelect: {
          ...state.cardSelect,
          cardId: firstCardId,
        },
      };
    }

    case types.FETCH_LIST_FAILURE:
      return {
        ...state,
        list: [],
        isLoaded: false,
        isLoading: false,
        error: action.payload,
      };

    case types.SET_CARD_SELECT:
      return {
        ...state,
        cardSelect: {
          ...state.cardSelect,
          cardId: action.payload,
        },
      };

    case types.SET_PAYU_TOKEN:
      return {
        ...state,
        cardSelect: {
          ...state.cardSelect,
          payuToken: action.payload,
        },
      };

    case types.RESET_PAYU_CARD_STATE:
      return { ...initialState };

    default:
      return state;
  }
}
